import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo, SyntheticEvent } from 'react';
import { isLevelModel } from '../../../mfcLogic/userProperties/level';
import useBadWordFilter from '../../Hooks/useBadWordFilter';
import { useModelColor } from '../../Hooks/useModelColor';
import { useUserSelector } from '../../Hooks/useUser';
import "./ModelName.linaria.module.css!=!./ModelName?./ModelName.linaria.module.css?css=H4sIAAAAAAAAA1XM0VLDIBCF4fs+iV7QKVWrpQ/DENiEtRtIgEIM03d3rEO1d/vPfnO2Ko3SSm4P/vOybh+qKsLBMUwwRqHBJQin6+ZmdJQf7oXvu8eqvXeJFcDBJtF5Ms0fo+RpKZipGowTqS/REyzt3XUSzdQPr49VfwyLNqA7i13DavmP7/WLh+DLH30nyWFcD7Sr2pMPIqvwxNjtfm4ozpLTPqLJNcGSmM8QevJFABFOEWODOUs+H7Ue1losJmBxUhqE8yWoqaFzlPwtz6WEeh+yaAy403XzDU9CuDBuAQAA"
interface ModelNameProps {
  color: string;
  isAnonymous?: boolean;
  name: string;
  modelId: number;
  className?: LinariaClassName;
  onClick?: (e: SyntheticEvent) => void;
  style?: CSSProperties;
}
const containerStyles = "atm_h_1h6ojuz atm_cs_8n312b atm_9s_1txwivl atm_bb_idpfg4 atm_ax_idpfg4 atm_7l_1emz6l0";
const nameStyles = "atm_sq_1l2sidv atm_vv_1q9ccgz atm_ks_15vqwwr";
const ModelName = memo((props: ModelNameProps) => {
  const {
    className,
    isAnonymous,
    style = {},
    color,
    name,
    onClick,
    modelId
  } = props;
  const modelColor = useModelColor(color);
  const resolvedName = isAnonymous ? name.split('_')[0] : name;
  const {
    username: displayName
  } = useBadWordFilter({
    username: resolvedName,
    replaceWith: 'x'
  });
  const level = useUserSelector(name, 'level');
  const isModel = isLevelModel(level);
  return <div data-testid="ModelTile__Name" style={{
    '--color': modelColor,
    ...style
  } as CSSProperties} id={`name-${modelId}`} className={cx(containerStyles, className)}>
            <span onClick={onClick} className={nameStyles}>
                {isModel ? resolvedName : displayName}
            </span>
        </div>;
});
export default ModelName;
export { ModelName };